import React, { useState } from 'react';
import * as PropTypes from 'prop-types';

import CollapsedSendMessagePopup from '../../common/CollapsedSendMessagePopup';
import { enhance } from './enhance';
import { usePageView } from '../../../hocs/usePageView';

const DependentExistingUser = ({
  guardianList,
  redirectToProfile,
  sendMessage,
  loading,
  intl: { formatMessage },
}) => {
  const [showPopup, togglePopup] = useState(true);
  usePageView('Add Dependent | Existing User');

  const handleSubmit = (body, recipientId) => {
    const message = { body, recipientId };
    sendMessage({ message });
  };
  const handleClose = () => {
    togglePopup(false);
    redirectToProfile();
  };

  return (
    <CollapsedSendMessagePopup
      icon="icon-plane"
      loading={loading}
      description={formatMessage({ id: 'dependent.dependentExists' })}
      profiles={guardianList}
      opened={showPopup}
      onSubmit={handleSubmit}
      onClose={handleClose}
    />
  );
};

DependentExistingUser.propTypes = {
  redirectToProfile: PropTypes.func,
  sendMessage: PropTypes.func,
  guardianList: PropTypes.array,
  loading: PropTypes.bool,
  intl: PropTypes.shape({
    formatMessage: PropTypes.func,
  }).isRequired,
};

export default enhance(DependentExistingUser);



// WEBPACK FOOTER //
// ./src/components/DependentForm/DependentExistingUser/index.jsx